import { columnsStyles } from "@insite/content-library/Widgets/ProductList/ProductListColumns";

columnsStyles.leftColumnGridItem = {
    width: [12, 12, 12, 3, 3],
};
columnsStyles.rightColumnGridItem = {
    width: [12, 12, 12, 9, 9],
};
